export const ContactClassIdEnum = {
  lookupTypeId: 5,
};
